import React, { useState } from "react";
import "../../css/UpcomingReleases.css";

export default function UpcomingReleases() {
  const [showReleases, setShowReleases] = useState(false);

  const releases = [
    {
      id: 1,
      title: "Advanced AI Features",
      description:
        "Advanced AI Features – Allow users to leverage AI to automatically generate automation scripts and use the generated scripts for test automation execution.",
      alignment: "left",
    },
    {
      id: 2,
      title: "Bitbucket Integration",
      description:
        "Connect your Bitbucket repos to TestOps to sync code and test plans for a smoother, integrated workflow.",
      alignment: "right",
    },
  ];

  return (
    <div className="upcoming-container">

      <div className="intro-box">
        <h1 className="intro-box-h1">
          We are constantly working on improving Froth TestOps to make it even better to serve your testing needs. This change log keeps you informed about the latest updates and improvements made to the platform.
        </h1>
        <hr />
      </div>

      <p
        onClick={() => setShowReleases(!showReleases)}
        className="toggle-text"
      >
        Explore What’s Coming Soon
      </p>

      {showReleases && (
        <div className="release-box">

          <h1 className="release-title">Upcoming Releases</h1>

          <div className="release-list">
            {releases.map((release) => (
              <div
                key={release.id}
                className={`release-item ${
                  release.alignment === "right" ? "align-right" : "align-left"
                }`}
              >

                <div className="release-header">
                  <span className="release-number">{release.id}</span>

                  <h3 className="release-heading">
                    {release.title}
                  </h3>
                </div>

                <p className={`release-desc ${
                  release.alignment === "right" ? "text-right" : ""
                }`}>
                  {release.description}
                </p>

              </div>
            ))}
          </div>

        </div>
      )}

      <h2 className="bottom-text">
        Let’s See The Recent Releases
      </h2>

    </div>
  );
}